import React from 'react';
import { MarqueeModel } from './MarqueemModel';


const Marquee = () => {

  const stockModel = MarqueeModel();
  return (
    <div className="ticker-container">
      <ul className="ticker-list">
        <li>
          {
            stockModel.trendingStocks && stockModel.trendingStocks.map((d: any, index: number) => (
              <a onClick={(e)=>stockModel.viewStockDetails(d)} className='mx-3' key={index}>
                {d.symbol} 
                <span className={((+d.perChange)) >= 0 ? 'up' : 'down'}>
                   <i className={((+d.perChange)) >= 0 ? 'fa-solid fa-arrow-up mx-2' : 'fa-solid fa-arrow-down mx-2'} ></i>{d.perChange}
                </span>
              </a>
            ))
          }
          {/* <a href="#">
            RGTI <span className="down"><i className="fa-solid fa-arrow-down"></i>1.418%</span>
          </a> */}
        </li>
        {/* Add more list items as needed */}
      </ul>
    </div>
  );
};


export default Marquee;
